<template>
  <div class="score-list">
    <div
        v-for="item in items"
        :key="item.key"
        class="score-row"
    >
      <div class="score-label">
        {{ item.label }}
      </div>

      <div class="score-value">
        {{ item.score }}
      </div>

      <div class="score-stars">
        <span
            v-for="star in 5"
            :key="star"
            class="star"
            :class="{ filled: star <= item.score }"
            :style="star <= item.score ? { color: item.color } : {}"
        >
          ★
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'TaskScores',
  props: {
    successfulRate: {
      type: Number,
      default: 0,
    },
    effectiveRate: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const items = computed(() => [
      {
        key: 'successful',
        label: 'Успешность задачи',
        score: props.successfulRate,
        color: '#39B6D6',
      },
      {
        key: 'effective',
        label: 'Эффективность эмоции',
        score: props.effectiveRate,
        color: '#7B61FF',
      },
    ])

    return {
      items,
    }
  },
}
</script>

<style scoped>
.score-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.score-row {
  display: grid;
  grid-template-columns: 1fr 36px auto;
  align-items: center;
  column-gap: 16px;
}

.score-label {
  font-size: 16px;
  line-height: 1.2;
}

.score-value {
  font-size: 24px;
  font-weight: 700;
  text-align: center;

  @media (max-width: 900px) {
    font-size: 20px;
  }
}

.score-stars {
  display: flex;
  gap: 6px;

  @media (max-width: 900px) {
    gap: 3px;
  }
}

.star {
  font-size: 38px;
  line-height: 1;
  color: #e6e6e6;

  @media (max-width: 900px) {
    font-size: 28px;
  }
}
</style>